module.exports = __webpack_public_path__ + "static/media/B.Tech_Course_Structure.43488aae.pdf";